export const getSession = async () => {
  const url = '/rpc.responsive.air.payment.getwalletpaymentsession.do.action';
  const params = new FormData();
  params.append('walletProvider', 'PayPal');

  const response = await fetch(url, {
    method: 'POST',
    headers: { Accept: 'application/json' },
    body: params,
  });
  const { model } = await response.json();

  return model;
};

export const initSession = async () => {
  const response = await getSession();

  return { token: response || null };
};
